import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import PageHeader from "@/components/PageHeader";
import Breadcrumbs from "@/components/Breadcrumbs";
import SEO from "@/components/SEO";

export default function Presse() {
  return (
    <div className="bg-black text-white min-h-screen flex flex-col">
      <SEO
        title="Presse | Wagenhofer Capital München"
        description="Ansprechpartner für Presseanfragen zu Wagenhofer Capital – der unternehmerischen Beteiligungs- und Verwaltungsgesellschaft aus dem Raum München."
        path="/presse"
      />
      <Navigation />
      <Breadcrumbs items={[{ label: "Presse", to: "/presse" }]} />
      <PageHeader
        overline="Presse"
        title={<>Hintergründe.<br/><span className="text-zinc-400">Auf Anfrage.</span></>}
        subtitle="Wir kommunizieren bewusst zurückhaltend. Journalistinnen und Journalisten finden hier den direkten Ansprechpartner sowie ein kurzes Unternehmensprofil."
      />

      <section className="section-y border-b border-white/5">
        <div className="container-x grid grid-cols-1 md:grid-cols-12 gap-10 lg:gap-16">
          <div className="md:col-span-5">
            <div className="overline mb-6">Pressekontakt</div>
            <div className="space-y-8">
              <div>
                <div className="overline mb-3 text-[#D4AF37]/80">E-Mail</div>
                <a
                  href="mailto:presse@wagenhofer.capital"
                  data-testid="press-email"
                  className="text-zinc-100 hover:text-[#D4AF37] transition-colors break-all text-base md:text-lg"
                >
                  presse@wagenhofer.capital
                </a>
              </div>
              <div>
                <div className="overline mb-3 text-[#D4AF37]/80">Anschrift</div>
                <address className="not-italic text-zinc-300 leading-relaxed text-sm">
                  Wagenhofer Capital GmbH<br/>
                  Max-Löw-Straße 27<br/>
                  85579 Neubiberg<br/>
                  Deutschland
                </address>
              </div>
              <div>
                <div className="overline mb-3 text-[#D4AF37]/80">Antwortzeit</div>
                <p className="text-zinc-300 text-sm leading-relaxed max-w-xs">
                  Presseanfragen beantworten wir in der Regel innerhalb weniger
                  Werktage – strukturiert, sachlich und vertraulich.
                </p>
              </div>
            </div>
          </div>

          <div className="md:col-span-7 md:pl-8 space-y-6 text-zinc-300 text-base md:text-lg leading-relaxed font-light">
            <div className="overline text-[#D4AF37]/80 mb-2">Kurzprofil</div>
            <h2 className="font-display text-2xl md:text-3xl lg:text-4xl tracking-tight font-medium leading-[1.1] mb-4">
              Unternehmerische Beteiligungen aus dem Raum München.
            </h2>
            <p>
              Wagenhofer Capital ist eine unternehmerisch geprägte Beteiligungs-
              und Verwaltungsgesellschaft mit Sitz im Raum München. Die
              Gesellschaft bündelt Beteiligungen, operative Projekte und
              unternehmerische Aktivitäten unter einer klaren Dachstruktur.
            </p>
            <p>
              Der Investmentfokus umfasst Unternehmensbeteiligungen,
              Gastronomie, Immobilien, Events und Entertainment, Dienstleistungen
              sowie ausgewählte zukunftsorientierte Geschäftsmodelle. Wagenhofer
              Capital versteht sich nicht als klassischer Finanzinvestor mit
              festem Exit-Horizont, sondern als aktiver, langfristig
              ausgerichteter Partner.
            </p>
            <p>
              Zentrale Werte sind Verlässlichkeit, Langfristigkeit,
              Bodenständigkeit, Diskretion und unternehmerische Verantwortung.
            </p>
            <p className="text-zinc-500 text-sm pt-6 border-t border-white/10">
              Bild- und Logodateien stellen wir auf Anfrage in geeigneter
              Auflösung zur Verfügung.
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
